<div id="dashboard-container">
  <div class="page-header">
    <app-toolbar-options icon="house">
      <div
        class="d-flex flex-row justify-content-between my-other-account"
        slot="start"
      >
        <div class="page-title">Overview</div>
      </div>
    </app-toolbar-options>
    <div
      class="d-flex flex-column flex-fill mt-4"
      *ngIf="showLimitedServiceBanner"
    >
      <app-limited-service-banner
        [toggles]="limitedServiceToggles"
      ></app-limited-service-banner>
    </div>
  </div>
  <div class="page-content" appanimatecss>
    <div class="d-flex align-items-stretch widgets-row-low">
      <div
        class="first-row d-flex {{
          screenWidth > 992 ? 'flex-row' : 'flex-column'
        }} w-100"
      >
        <app-member-view-overview
          *featuretoggle="memberProfileSummaryFeatureToggle"
          class="d-flex flex-fill widget-1 w-50"
          [ngClass]="{ 'me-3': addSpacingForWidget && screenWidth > 992 }"
        >
        </app-member-view-overview>

        <app-component-wrapper
          id="app-consolidate-super-wrapper"
          icon="merge_type"
          header="Consolidate your super"
          *featuretoggle="consolidateSuperFeatureToggle"
          class="d-flex flex-fill widget-1 w-50"
          [ngClass]="{ 'ms-3': addSpacingForWidget && screenWidth > 992 }"
        >
          <div class="d-flex flex-column" slot="start">
            <app-consolidate-super class="w-100"></app-consolidate-super>
          </div>
          <div class="d-flex flex-row components-actions" slot="actions">
            <app-button
              icon="{{ 'BTN.consolidate-super.start.icon' | translate }}"
              title="Start"
              (onClick)="onStartClick()"
            >
            </app-button>
          </div>
        </app-component-wrapper>
      </div>
    </div>

    <app-component-wrapper
      class="historical-graph-component"
      icon=""
      header=""
      *featuretoggle="accountBalWithGraphFeatureToggle"
    >
      <div class="d-flex flex-column" slot="start">
        <app-historical-chart-view></app-historical-chart-view>
      </div>
    </app-component-wrapper>

    <app-component-wrapper
      id="app-investment-edit-wrapper"
      icon="price_change"
      header="Investment Options"
      *featuretoggle="manageInvestmentsFeatureToggle"
    >
      <div class="d-flex flex-column" slot="start">
        <app-investment-edit
          [showOptions]="false"
          [isDashboardView]="true"
        ></app-investment-edit>
        <div
          class="d-flex flex-row components-actions investment-edit"
          *featuretoggle="updateInvestmentsFeatureToggle"
        >
          <app-button
            loading
            title="Manage Investments"
            icon="edit"
            routerLink="/investment"
          >
          </app-button>
        </div>
      </div>
    </app-component-wrapper>

    <div class="w-100 academy mt-4">
      <a target="_blank" href="https://vervesuper.com.au/learn-members/">
        <img
          class="w-100"
          src="https://vervassets.blob.core.windows.net/web/dashboard-learn3.png"
        />
      </a>
    </div>
  </div>
</div>
